"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTruthy = exports.isFalsy = exports.isNullLike = void 0;
function isNullLike(x) {
    return x === null || x === undefined;
}
exports.isNullLike = isNullLike;
function isFalsy(x) {
    return !x;
}
exports.isFalsy = isFalsy;
function isTruthy(x) {
    return !!x;
}
exports.isTruthy = isTruthy;
//# sourceMappingURL=boolean.js.map